import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { PendoService } from 'analytics-lib';

export interface IHamburgerMenuItem {
  label: string;
  icon?: IHamburgerIcon;
  iconAfter?: IHamburgerIcon;
  action?: () => void;
  tooltip?: string;
  disabled?: boolean;
  isCurrentSection?: boolean;
  isExternalLink?: boolean;
  showNewTabIcon?: boolean;
  customClass?: string;
  imageIcon?: string;
  subItems?: IHamburgerMenuItem[];
  expanded?: boolean;
}

interface IHamburgerIcon {
  name: string;
  class?: string;
}

@Component({
  selector: 'lib-hamburger',
  templateUrl: './hamburger.component.html',
  styleUrls: ['./hamburger.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, MatIconModule, MatTooltipModule],
})
export class HamburgerComponent {
  @Input() isOpen = false;
  @Input() menuTitle = 'Menu';
  @Input() menuItems: IHamburgerMenuItem[] = [];
  @Input() homeRoute = '';
  @Input() homeTooltip = 'Home';

  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() menuToggle = new EventEmitter<boolean>();

  @ViewChild('burgerContainer') burgerContainer: any;

  constructor(private pendoService: PendoService, private host: ElementRef<HTMLElement>) {}

  @HostListener('document:keydown.esc')
  protected handleEscapeEvent() {
    if (this.isOpen) {
      this.pendoService?.recordEvent('Escape key pressed - to close hamburger');
      this.closeHamburger();
    }
  }

  @HostListener('document:click', ['$event'])
  protected handleClickEvent(event: MouseEvent) {
    if (this.isOpen && !this.host.nativeElement.contains(event.target as Node)) {
      this.closeHamburger();
      this.pendoService?.recordEvent('Click outside hamburger menu - to close hamburger');
    }
  }

  @HostListener('document:keydown.alt.shift.m')
  protected handleAltShiftMEvent() {
    if (!this.isOpen) {
      this.openHamburger();
      this.pendoService?.recordEvent('Alt + Shift + M key pressed - to open hamburger');
    } else {
      this.closeHamburger();
      this.pendoService?.recordEvent('Alt + Shift + M key pressed - to close hamburger');
    }
  }

  get hamburgerOpen() {
    return this.isOpen;
  }

  set hamburgerOpen(value: boolean) {
    this.isOpen = value;
    this.isOpenChange.emit(value);
  }

  openHamburger() {
    this.hamburgerOpen = true;
    this.menuToggle.emit(true);
  }

  closeHamburger() {
    this.hamburgerOpen = false;
    this.menuToggle.emit(false);
  }

  onMenuItemClick(item: IHamburgerMenuItem) {
    if (item.subItems) {
      item.expanded = !item.expanded;
    } else if (item.action && !item.disabled) {
      item.action();
      this.closeHamburger();
    }
  }
}
